(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wb-back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var button = document.querySelector('[data-wb-top]');
    if (!button) return;

    button.hidden = false;

    var threshold = Math.max(400, window.innerHeight * 0.6);
    var ticking = false;

    function update() {
      button.classList.toggle('is-on', window.scrollY > threshold);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    button.addEventListener('click', function () {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wb-whatsapp"] && !Shopify.designMode) return;
  try {
    // The button is fixed to the bottom-right, which is exactly where the
  // footer credit sits. Rather than nudge it and hope, hide it whenever the
  // footer enters the viewport.
  (function () {
    var button = document.querySelector('.wb-wa');
    if (!button || !('IntersectionObserver' in window)) return;

    var footer = document.querySelector('.wb-ft, footer');
    if (!footer) return;

    new IntersectionObserver(
      function (entries) {
        button.classList.toggle('is-hidden', entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -40% 0px', threshold: 0 }
    ).observe(footer);
  })();
  } catch(e) { console.error(e); }
})();

})();
